enum types {
  SET_TERMS_ACCEPTED = "SET_TERMS_ACCEPTED",
}
export default types;
